module.exports = __webpack_public_path__ + "front/img/43.f4939333.png";